import { render, staticRenderFns } from "./SalaryContent.vue?vue&type=template&id=682eeed4"
import script from "./SalaryContent.vue?vue&type=script&lang=js"
export * from "./SalaryContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports